export default __webpack_public_path__ + "static/media/logo-light.d183a7a7.png";